export default __webpack_public_path__ + "images/parent-signup/face_icon-065c8e325b457e144dba1cb496833ea4.svg";